import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Play, Pause } from 'lucide-react';
function VideoPlayer({
  video,
  index
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="aspect-[9/16] bg-black rounded-2xl relative overflow-hidden shadow-xl border border-gray-200 group cursor-pointer" onClick={togglePlay} data-id="element-250">
      <video ref={videoRef} src={video.url} className="w-full h-full object-cover" playsInline preload="metadata" onEnded={() => setIsPlaying(false)} data-id="element-251" />

      {/* Play Button Overlay */}
      {!isPlaying && <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors z-10" data-id="element-252">
          <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg border border-white/30" data-id="element-253">
            <Play className="w-8 h-8 text-white fill-current ml-1" data-id="element-254" />
          </div>
        </div>}

      {/* Gradient Overlay */}
      <div className={`absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/80 to-transparent pointer-events-none transition-opacity duration-300 ${isPlaying ? 'opacity-0' : 'opacity-100'}`} data-id="element-255" />

      {/* Text Content */}
      <div className={`absolute bottom-4 left-4 right-4 pointer-events-none transition-opacity duration-300 ${isPlaying ? 'opacity-0' : 'opacity-100'}`} data-id="element-256">
        <p className="text-white font-bold text-sm drop-shadow-md" data-id="element-257">
          {video.title}
        </p>
        <div className="flex text-[#10B981] mt-1 drop-shadow-md" data-id="element-258">
          {[...Array(video.stars)].map((_, s) => <span key={s} data-id="element-259">★</span>)}
        </div>
      </div>
    </motion.div>;
}
export function VideoSection() {
  const videos = [{
    url: 'https://cdn.magicpatterns.com/uploads/6kSYeGL8PCiddjXAbedoFW/74705e62a10946a4b39ee3aeb8df6382.HD-720p-1.6Mbps-52533377.undefined',
    title: 'How to Depuff Your Body',
    stars: 5
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/mRLWCNcymgWbneLSnMUCdy/88df2117c4f040aa8dd57ca681411a33.HD-720p-1.6Mbps-52533394.undefined',
    title: 'Detox Your Lymphatic System',
    stars: 5
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/nmV4oTpfKeeCFvsdVD9TcL/cd1dd44a3371498bb356951c359454a0.HD-720p-1.6Mbps-52532876.undefined',
    title: "Why Didn't We Know This?!",
    stars: 5
  }];
  return <section className="py-24 bg-white" data-id="element-260">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="text-center mb-12" data-id="element-262">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20]" data-id="element-263">
            Real People. Real Transformations.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-264">
          {videos.map((video, i) => <VideoPlayer key={i} video={video} index={i} data-id="element-265" />)}
        </div>
      </div>
    </section>;
}